<template>
  <div class="t1">
    <nav_list></nav_list>
    <div v-if="info.id > 0" class="v3_body">
      <navv :title="info.paths.title" :en="info.en_tit">
      </navv>
      <div class="w0">
        <div class="wl1">



          <div class="cont" v-html="txt">

          </div>
        </div>

        <div class="wl2">
          <div class="titz" v-for="(itm, j) in tit" :key="j" @click="jump('/article?c=' + itm.id)" >
             {{ itm[cache('lang_config')] }}
          </div>


        </div>


      </div>

    </div>

    <div style=" text-align: center;">
      <el-button class="btnz" @click="jump('/')">{{ $lang(51494)}} </el-button>
    </div>
  </div>
</template>

<script>


import nav_list from '../index/nav_list.vue';
export default {
  name: "bus_list",

  components: {
    nav_list,
  },

  data() {
    return {
      a: 'bus_list',
      tit : [],
      article : [],
      info:  {
        id : 0,
      },
      id: 1,
      txt: '',
      activeName: 0
    };
  },
  mounted(e) {
    if (!this.$route.query.id) {
      return this.jump('/')
    }
    this.id = this.$route.query.id
    this.f5()
  },

  methods: {

    f5() {
      this.get("/index/article_info", { id: this.id },  ).then((e) => {

        this.tit = e.tit
        this.info = e.info
        this.article = e.article
        this.txt = this.info[this.cache('lang_config')]
        this.cache('list_map', '')
        document.title = this.info.paths.title + '-' + this.web_tit;
      });
    },

  }
}
</script>
<style scoped>
.act {

  color: #1c5098 !important;
}




.titz {
  font-size: 15px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-weight: 500;
  color: #333;
  border: 1px solid #f0f0f0;
  background: #fff;
  border-radius: 6px;
  text-align: center;
  padding: 12px 20px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.titz:hover {
  background: #f8f8f8;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}


.cont {
  margin: auto;
  padding: 30px;
  overflow: hidden;
  width: 62vw;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  line-height: 1.8;
  font-size: 16px;
  color: #333;
}




.wl2 {
  flex: 0 0 20%;
  padding: 15px;
  text-align: center;
  position: fixed;
  z-index: 2;
  left: 82vw;
  top: 170px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/pages/note/info.vue